import { jsx as _jsx } from "react/jsx-runtime";
import { Sidebar as Menu } from "@hourly-hds/components";
export const Sidebar = ({ items, selectedItem = "", onChange, }) => {
    const menuItems = items
        .filter((item) => item.predicate?.() ?? true)
        .map(({ key, label, children, leftDecoration }) => ({
        key,
        label,
        leftDecoration,
        children: children
            ?.filter((child) => child.predicate?.() ?? true)
            .map(({ key, label, leftDecoration }) => ({
            key,
            label,
            leftDecoration,
        })),
    }));
    const allKeys = new Set();
    menuItems.forEach((item) => {
        allKeys.add(item.key);
        item.children?.forEach((child) => {
            allKeys.add(child.key);
        });
    });
    const selectedKey = Array.from(allKeys).reduce((best, key) => {
        const i = selectedItem.lastIndexOf(key);
        if (i === -1)
            return best;
        return !best || key.length > best.length ? key : best;
    }, "");
    return (_jsx(Menu, { selectedItemKey: selectedKey, onChange: (selectedItem) => onChange(selectedItem), children: menuItems.map((item) => item.children ? (_jsx(Menu.Group, { label: item.label, leftDecoration: item.leftDecoration, children: item.children.map((child) => (_jsx(Menu.Item, { itemKey: child.key, leftDecoration: child.leftDecoration, children: child.label }, child.key))) }, item.key)) : (_jsx(Menu.Item, { itemKey: item.key, leftDecoration: item.leftDecoration, children: item.label }, item.key))) }));
};
